// extracted by mini-css-extract-plugin
export default {"mainContainer":"register_mainContainer__mM6im"};